const a = (e) => e.toISOString().split(".")[0] + "Z", g = (e) => {
  const t = /* @__PURE__ */ new Date(), n = new Date(t.getTime() - (e + 1) * 24 * 60 * 60 * 1e3);
  return {
    id: `agent-${e + 1}`,
    name: `Conversational Agent ${e + 1}`,
    description: e % 2 === 0 ? `Description for agent ${e + 1}` : "",
    agentType: "CONVERSATIONAL",
    reformulationModelId: `reformulation-model-${e % 3 + 1}`,
    passageRetrievalModelId: `passage-model-${e % 3 + 1}`,
    answerGenerationModelId: `answer-model-${e % 3 + 1}`,
    numberOfItemsToConsider: e % 2 === 0 ? 50 + e * 5 : void 0,
    followUpEnabled: !0,
    createdDate: a(n),
    modifiedDate: a(t)
  };
}, A = (e, t) => {
  const n = (t == null ? void 0 : t.page) ?? 1, r = (t == null ? void 0 : t.perPage) ?? 25, d = Array.from({ length: e }, (s, c) => g(c));
  t != null && t.sortingType && d.sort((s, c) => {
    const M = s[t.sortingType], w = c[t.sortingType], i = String(M ?? "").localeCompare(String(w ?? ""));
    return t.sortingOrder === "DSC" ? -i : i;
  });
  const l = (n - 1) * r, m = d.slice(l, l + r), f = Math.ceil(e / r);
  return {
    pagination: {
      page: n,
      perPage: r,
      totalItems: e,
      totalPages: f
    },
    items: m
  };
}, u = (e) => {
  const t = a(/* @__PURE__ */ new Date());
  return {
    id: `agent-${Date.now()}`,
    name: e.name,
    description: e.description,
    agentType: e.agentType,
    reformulationModelId: e.reformulationModelId,
    passageRetrievalModelId: e.passageRetrievalModelId,
    answerGenerationModelId: e.answerGenerationModelId,
    numberOfItemsToConsider: e.numberOfItemsToConsider,
    followUpEnabled: e.followUpEnabled,
    createdDate: t,
    modifiedDate: t
  };
};
let o = [];
const I = (e = 5) => {
  o = Array.from({ length: e }, (t, n) => g(n));
}, D = () => [...o], p = (e) => {
  o.unshift(e);
}, T = (e, t) => {
  const n = o.findIndex((r) => r.id === e);
  return n === -1 ? null : (o[n] = {
    ...o[n],
    ...t,
    modifiedDate: a(/* @__PURE__ */ new Date())
  }, o[n]);
}, S = (e) => {
  const t = o.findIndex((n) => n.id === e);
  return t === -1 ? !1 : (o.splice(t, 1), !0);
}, k = (e) => o.find((t) => t.id === e), y = (e, t = 2e3) => new Promise((n) => {
  setTimeout(() => n(e), t);
});
I(5);
export {
  p as addMockAgent,
  u as createMockAgentFromRequest,
  g as createMockAgentItem,
  A as createMockAgentListResponse,
  S as deleteMockAgent,
  k as getMockAgent,
  D as getMockAgentStore,
  I as initializeMockAgentStore,
  T as updateMockAgent,
  y as withDelay
};
//# sourceMappingURL=AgentConfigurationResource.mocks.js.map
